const monetatePageType = {
    Home: 'main',
    ProductListing: 'category',
    ProductDetail: 'product',
    PurchaseFunnel: 'cart'
};
function mapMonetatePageType(seoPageType) {
    return monetatePageType[seoPageType] || 'other_page';
}

export { mapMonetatePageType };
//# sourceMappingURL=map-monetate-page-type.js.map
